module.exports = __webpack_public_path__ + "img/logo.e41d855f.png";